export default "__VITE_ASSET__d43c5988__"